module.exports = __webpack_public_path__ + "media/fyaz.d00f6b15.mp4";